import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, signal } from '@angular/core';
import { ScrollBarService } from '@shared/scroll/scrollbar.service';
import { NgScrollbar } from 'ngx-scrollbar';
import { expoAnimations } from '@shared/animations/expo-animations';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'scroll-top',
  templateUrl: './scroll-top.component.html',
  styleUrls: ['./scroll-top.component.scss'],
  animations: [expoAnimations],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule
  ]
})
export class ScrollTopComponent implements OnInit {

  scrollBar: NgScrollbar;
  visible = signal(false);
  isNewsCaroulselPage: boolean = false;   //Dichiaro isNewsCaroulselPage come false, poichè diventerà true quando il router sarà su hall page

  constructor(
    private scrollBarService: ScrollBarService,
    private router: Router
  ) { }

  ngOnInit(): void{
    this.scrollBar = this.scrollBarService.mainScrollbar;
    this.scrollBar.viewport.nativeElement.addEventListener('scroll', (ev: MouseEvent) => {
      this.visible.set(this.scrollBar.viewport.scrollTop > 200);

      //Se isNewsCaroulselPage avrà il router.url che includerà /online-fair oppure /hall metterò isNewsCaroulselPage=true altrimenti metterò false
      if(this.router.url.includes('/online-fair') || this.router.url.includes('/hall') && !this.router.url.includes('/stand'))
      {
        this.isNewsCaroulselPage = true;
      }
      else{
        this.isNewsCaroulselPage = false;
      }
  
    });
  }

  scrollToTop(): void{
    this.scrollBar.scrollTo({top: 0, duration: 300});
  }
}
